export class SupplierWorktimeControl {
    public supplierWorktimeControlID: string;
    public text: string;
    public photoPlaceholderUrl: string;
    public isPhotoRequired: boolean;
    public additionalInfoPlaceholder: string;
    public isAdditionalInfoRequired: boolean;
}
